import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                91<span className="text-primary-500">抖音</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              91抖音是一个专注短视频浏览与分享的平台，汇聚娱乐、生活、音乐、美食等热门分类内容，
              帮助年轻用户发现灵感、分享快乐。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-tiktok-fill"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-600"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-950">网站导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li><Link to="/" className="transition-colors hover:text-primary-600">首页</Link></li>
              <li><Link to="/search" className="transition-colors hover:text-primary-600">搜索视频</Link></li>
              <li><Link to="/favorites" className="transition-colors hover:text-primary-600">我的收藏</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-primary-600">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-950">热门分类</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              {categories.map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="transition-colors hover:text-primary-600"
                  >
                    {category.name}视频
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 91抖音 短视频分享平台. 本站为内容展示演示站点，视频播放为前端预览效果。</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-primary-600">用户协议</Link>
            <Link to="/about" className="transition-colors hover:text-primary-600">隐私政策</Link>
            <Link to="/about" className="transition-colors hover:text-primary-600">联系反馈</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}